import OT from '@opentok/client';

import {
  SUCCESS_CHECK_BROWSER_SUPPORT,
  FAIL_CHECK_BROWSER_SUPPORT,
  UPDATE_SCREEN_SHARING_EXTENSION_INSTALLED,
} from '../action_types';

export const successCheckBrowserSupport = () => ({ type: SUCCESS_CHECK_BROWSER_SUPPORT });
export const failCheckBrowserSupport = () => ({ type: FAIL_CHECK_BROWSER_SUPPORT });

export const checkSystemRequirements = () => {
  if (OT.checkSystemRequirements() === 1) {
    return successCheckBrowserSupport();
  }

  return failCheckBrowserSupport();
};

export const updateExtensionInstalled = (payload) => (
  { type: UPDATE_SCREEN_SHARING_EXTENSION_INSTALLED, payload }
);
